<template>
  <div class="home-price-slider-card">
    <div class="card">
      <v-card class="transparent pa-6" width="400" height="427" flat tile>
        <!-- Price -->
        <div class="d-flex">
          <h6 class="heading-h6">Loan amount</h6>
          <v-spacer />
          <h6 class="heading-h6">R {{ price }}</h6>
        </div>

        <div class="mt-3">
          <vue-slider
            v-model="price"
            :min="minPrice"
            :max="maxPrice"
            :interval="interval"
            dotSize="20"
            tooltip="none"
          />
        </div>

        <div class="d-flex">
          <p class="b-body-2 gray700--text">R {{ minPrice }}</p>
          <v-spacer />
          <p class="b-body-2 gray700--text">R {{ maxPrice }}</p>
        </div>

        <!-- Days -->
        <div class="d-flex mt-1">
          <h6 class="heading-h6">Loan period</h6>
          <v-spacer />
          <h6 class="heading-h6">{{ formattedLoanPeriod }}</h6>
        </div>

        <div class="mt-3">
          <vue-slider
            v-model="loanPeriodIndex"
            :min="0"
            :max="loanPeriods.length - 1"
            :dot-size="20"
            :tooltip="'none'"
          />
        </div>

        <div class="d-flex">
          <p class="b-body-2 gray700--text">{{ loanPeriods[0] }} days</p>
          <v-spacer />
          <p class="b-body-2 gray700--text">
            {{ loanPeriods[loanPeriods.length - 1] / 30 }} months
          </p>
        </div>

        <!-- Repayable Amount -->
        <div class="d-flex mt-n3">
          <p class="b-body-1">
            Repayable Amount
            <span class="b-body-1 font-weight-bold" style="color: #08338f">
              R {{ amountRepayable }}
            </span>
          </p>

          <div class="show-card pointer">
            <!-- img -->
            <v-img
              alt="union"
              class="union pointer mt-1 ml-2"
              contain
              src="@/assets/img/public/pages/home/mobile/union.svg"
              max-width="14"
            />

            <v-card class="icon-card" width="230" height="163" elevation="1">
              <p class="icon-text">
                Interest rate day: 0,16% new clients, 0,1% subsequent clients.
                <br />
                Initial fee: 16,5% of first R 1 000 lent, 10% of loan amount
                over R 1 000, +VAT.Limited 15% of loan amount, +VAT. Service fee
                R 69 month.
              </p>

              <p class="icon-text mt-n1">
                Based on Chapter 5 regulations of NCA no 34 of 2005
              </p>
            </v-card>
          </div>
        </div>

        <!-- Payday -->
        <div v-if="loanPeriods[loanPeriodIndex] < 60" class="d-flex mt-n3">
          <p class="b-body-1">
            Payday
            <span class="b-body-1 font-weight-bold" style="color: #08338f">
              {{ payday }}
            </span>
          </p>
        </div>

        <!-- <p class="b-body-2 gray700--text mt-n1">
          Use the loan calculator as reference only. A loan offer can only be
          made once we’ve calculated your affordability.
        </p> -->

        <v-btn
          :to="{ name: 'RegistrationPage' }"
          class="b-button #08338F"
          height="48"
          width="100%"
          elevation="0"
          style="background-color: #08338f; color: white"
        >
          APPLY HERE
        </v-btn>
        <br />
        <br />
        <p class="b-body-2 gray700--text mt-n1">
          Use the loan calculator as reference only. A loan offer can only be
          made once we&apos;ve calculated your affordability.
        </p>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "LimeLoansHomepriceslidercard",

  data() {
    return {
      minPrice: 500,
      maxPrice: 8000,
      price: 1700,
      interval: 100,
      loanPeriodIndex: 0,
      loanPeriods: [
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        60,
        90,
        120,
        150,
        180, // 2, 3, 4, 5, 6 months (converted to days)
      ],
      interest: 24.65,
      amountRepayable: 1246.5,
      payday: "",

      initialFeeAmount: 165,

      serviceFeeFor1stMonth: 6.9,
      serviceFeeFor2ndMonth: 69,

      interestRatePerDay5Percent: 161 / 100000,
      interestRatePerDay3Percent: 1 / 1000,
      interestPerDay: 1.1725,
    };
  },

  mounted() {
    this.setAmountRepayable(this.price, this.days);
    this.payday = this.moment().add(this.days, "d").format("D MMM YYYY");
  },

  computed: {
    // Calculate the actual days based on loanPeriodIndex
    days() {
      return this.loanPeriods[this.loanPeriodIndex];
    },
    // Format loan period display (days or months)
    formattedLoanPeriod() {
      if (this.days <= 37) {
        return `${this.days} days`;
      } else {
        const months = this.days / 30;
        return `${months} month${months > 1 ? "s" : ""}`;
      }
    },
  },

  watch: {
    price(val) {
      this.setAmountRepayable(val, this.days);
    },

    loanPeriodIndex(val) {
      const actualDays = this.loanPeriods[val];
      this.setAmountRepayable(this.price, actualDays);
      this.payday = this.moment().add(actualDays, "d").format("D MMM YYYY");
    },
  },

  methods: {
    setAmountRepayable(price, days) {
      var loanAmount = price; // C2
      var loanPeriod = days; // C3
      var interestRatePercentPerYear = 36 / 100; // C9
      var interestRatePercentPerDay = interestRatePercentPerYear / 360; // C11
      var serviceFeePerOneMonth = 69; // C12

      var today = this.moment();
      var numberOfDaysInMonth = this.moment(today, "YYYY-MM").daysInMonth(); // 1st month days C15
      var todaysDay = today.format("DD");

      var firstMonthLoanPeriod = numberOfDaysInMonth - todaysDay + 1; // C16
      // var secondMonthLoanPeriod = 0; // C17

      var numberOfMonths = 1; // C14

      if (numberOfDaysInMonth - todaysDay + 1 < loanPeriod) {
        numberOfMonths++;
      }

      if (numberOfMonths == 1) {
        firstMonthLoanPeriod = loanPeriod;
      }

      var firstMonthServiceFee =
        (serviceFeePerOneMonth * firstMonthLoanPeriod) / numberOfDaysInMonth; // C19
      var secondMonthServiceFee = 0; // C20

      if (numberOfMonths == 2) {
        secondMonthServiceFee = serviceFeePerOneMonth;
      }

      var initialFeeAmount = this.initialFeeAmount; // C23

      if (loanAmount >= 1000) {
        initialFeeAmount = this.initialFeeAmount + (loanAmount - 1000) * 0.1;
      }

      if (initialFeeAmount > loanAmount * 1.15 * 0.15) {
        initialFeeAmount = loanAmount * 0.15;
      }

      var initialFeeAmountArray = [
        initialFeeAmount,
        loanAmount * 1.15 * 0.15,
        1050,
      ];

      initialFeeAmount = Math.min(...initialFeeAmountArray) * 1.15;

      var interestPerDay =
        (loanAmount + initialFeeAmount) * interestRatePercentPerDay; //C22

      var interestAmount = interestPerDay * loanPeriod; // C24

      var serviceFeeAmount = firstMonthServiceFee + secondMonthServiceFee; // C25

      this.amountRepayable = (
        loanAmount +
        initialFeeAmount +
        interestAmount +
        serviceFeeAmount
      )
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,");

      this.days = days;
    },
  },
};
</script>

<style lang="scss" scoped>
.heading-h6 {
  font-family: "Raleway";
  font-size: 20px;
  font-weight: 700;
  line-height: 25px;
  letter-spacing: 0px;

  font-style: normal;
}

.b-body-2 {
  font-family: "Noto Sans Display";
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0.01em;
}

.card {
  position: relative;
}

.icon-card {
  /* Auto layout */
  display: none;
  position: absolute;
  top: 150px;
  right: -140px;

  padding: 4px 8px 6px;

  width: 230px;
  height: 163px;

  /* Neutral/00 */

  background: #fff;

  box-shadow: 0px 0px 8px rgba(61, 61, 61, 0.12),
    0px 2px 4px rgba(61, 61, 61, 0.06);
  border-radius: 4px;
  filter: drop-shadow(0px 0px 16px rgba(61, 61, 61, 0.12))
    drop-shadow(0px 4px 8px rgba(61, 61, 61, 0.06));

  z-index: 5;
}

.icon-text {
  //styleName: 12 XS/strike;
  font-family: "Noto Sans Display";
  font-style: normal;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.01em;
}

.show-card:hover .icon-card {
  display: block;
}

// @media (min-width: 769px) and (max-width: 1470px) {
@media only screen and (max-width: 1470px) {
  .icon-card {
    top: 40px;
    right: 10px;
  }
}
</style>
